export type ColorTokens = {
  bg: string;
  surface: string;
  surfaceSubtle: string;
  surfaceInset: string;

  border: string;
  borderStrong: string;
  borderSubtle: string;

  text: string;
  textSecondary: string;
  textTertiary: string;
  textInverse: string;

  accent: string;
  accentHover: string;
  accentActive: string;
  accentSubtle: string;
  accentText: string;

  success: string;
  successSubtle: string;
  warning: string;
  warningSubtle: string;
  danger: string;
  dangerSubtle: string;
  info: string;
  infoSubtle: string;

  aiGradientFrom: string;
  aiGradientTo: string;

  focusRing: string;
};

export const lightColors: ColorTokens = {
  bg: '#FAFAF7',
  surface: '#FFFFFF',
  surfaceSubtle: '#F4F4EF',
  surfaceInset: '#EDEDE8',

  border: '#ECECE8',
  borderStrong: '#D6D6D0',
  borderSubtle: '#F2F2EE',

  text: '#1A1A1A',
  textSecondary: '#5B5B57',
  textTertiary: '#8A8A85',
  textInverse: '#FFFFFF',

  accent: '#EA580C',
  accentHover: '#C2410C',
  accentActive: '#9A3412',
  accentSubtle: '#FFF1E5',
  accentText: '#9A3412',

  success: '#16A34A',
  successSubtle: '#E8F5EE',
  warning: '#D97706',
  warningSubtle: '#FBF1E1',
  danger: '#DC2626',
  dangerSubtle: '#FBE9E9',
  info: '#2563EB',
  infoSubtle: '#E8EFFC',

  aiGradientFrom: '#FEF0E1',
  aiGradientTo: '#FAFAF7',

  focusRing: 'rgba(234, 88, 12, 0.25)',
};

// Dark palette mirrors the tribed.io landing (BaseLayout.astro): near-black
// surfaces, #00FF84 accent, faint warm-white lines. Keep the two in sync.
export const darkColors: ColorTokens = {
  bg: '#070808',
  surface: '#101211',
  surfaceSubtle: '#171A18',
  surfaceInset: '#0B0C0C',

  border: 'rgba(244, 244, 240, 0.1)',
  borderStrong: 'rgba(244, 244, 240, 0.2)',
  borderSubtle: 'rgba(244, 244, 240, 0.06)',

  text: '#F4F4F0',
  textSecondary: '#C8CDC9',
  textTertiary: '#8E938F',
  textInverse: '#002814',

  accent: '#00FF84',
  accentHover: '#4DFFA6',
  accentActive: '#00E676',
  accentSubtle: 'rgba(0, 255, 132, 0.08)',
  accentText: '#00FF84',

  success: '#00FF84',
  successSubtle: 'rgba(0, 255, 132, 0.1)',
  warning: '#F59E0B',
  warningSubtle: '#2A1F0A',
  danger: '#FF5A60',
  dangerSubtle: 'rgba(255, 90, 96, 0.1)',
  info: '#3B82F6',
  infoSubtle: '#0F1A2A',

  aiGradientFrom: '#0A1F14',
  aiGradientTo: '#070808',

  focusRing: 'rgba(0, 255, 132, 0.35)',
};
